import { Route } from "@angular/router";
import { Federations } from "../organisation/models/federation";

export const MembersPaths = {
  Teams: "ledengroepen",
  TeamAdd: "ledengroepen/toevoegen",
  TeamEdit: (teamId: number | string) => `ledengroepen/bewerken/${teamId}`,
  TeamFlow: "ledengroepen/doorstroming",
  WaitingList: "wachtlijst",
  WaitingListEdit: (waitingMemberId: number | string) => `wachtlijst/edit/${waitingMemberId}`,
  Overview: "overzicht",
  Register: "inschrijven",
  Start: "start",
  Import: "importeren",
  Transfer: "overzetten",
  TransferTable: (draftId: number | string) => `overzetten/${draftId}`,
  Update: (oldMemberId: number | string, newMemberId: number | string) =>
    `${oldMemberId}/update/${newMemberId}`,
};

export default [
  {
    path: MembersPaths.Start,
    loadComponent: () =>
      import("./pages/member-start/member-start.component").then((c) => c.MemberStartComponent),
    data: {
      breadcrumb: "Snel starten",
      title: "Leden",
    },
  },
  {
    path: MembersPaths.Teams,
    loadComponent: () =>
      import("./pages/team-list/team-list.component").then((c) => c.TeamListComponent),
    data: {
      breadcrumb: "Ledengroepen",
      title: "Ledengroepen",
      subscriptionTypes: [1],
      federations: [Federations.Vlamo],
    },
  },
  {
    path: MembersPaths.TeamAdd,
    loadComponent: () =>
      import("./pages/team-edit/team-edit.component").then((c) => c.TeamEditComponent),
    data: {
      breadcrumb: "Ledengroep toevoegen",
      title: "Ledengroep toevoegen",
      subscriptionTypes: [1],
      federations: [Federations.Vlamo],
    },
  },
  {
    path: MembersPaths.TeamEdit(":id"),
    loadComponent: () =>
      import("./pages/team-edit/team-edit.component").then((c) => c.TeamEditComponent),
    data: {
      breadcrumb: "Ledengroep bewerken",
      title: "Ledengroep bewerken",
      subscriptionTypes: [1],
      federations: [Federations.Vlamo],
    },
  },
  {
    path: MembersPaths.TeamFlow,
    loadComponent: () =>
      import("./pages/team-flow/team-flow.component").then((c) => c.TeamFlowComponent),
    data: {
      breadcrumb: "Doorstroming",
      title: "Doorstroming",
      subscriptionTypes: [1],
    },
  },
  {
    path: MembersPaths.WaitingList,
    loadComponent: () =>
      import("./pages/waitinglist/waitinglist.component").then((c) => c.WaitinglistComponent),
    data: {
      breadcrumb: "Wachtlijst beheren",
      title: "Wachtlijst beheren",
      subscriptionTypes: [1],
    },
  },
  {
    path: MembersPaths.WaitingListEdit(":id"),
    loadComponent: () =>
      import("./pages/waitinglist-edit/waitinglist-edit.component").then(
        (c) => c.WaitinglistEditComponent
      ),
    data: {
      breadcrumb: "Wachtlid bewerken",
      title: "Wachtlid bewerken",
      subscriptionTypes: [1],
    },
  },
  {
    path: MembersPaths.Overview,
    loadComponent: () =>
      import("./pages/member-list/member-list.component").then((c) => c.MemberListComponent),
    data: {
      breadcrumb: "Leden beheren",
      title: "Leden beheren",
      subscriptionTypes: [1],
      federations: [Federations.Vlamo],
    },
  },
  {
    path: MembersPaths.Register,
    loadComponent: () =>
      import("./pages/member-add/member-add.component").then((c) => c.MemberAddComponent),
    data: {
      breadcrumb: "Nieuw lid inschrijven",
      title: "Nieuw lid inschrijven",
      subscriptionTypes: [1],
      federations: [Federations.Vlamo],
    },
  },
  {
    path: MembersPaths.Import,
    loadComponent: () =>
      import("./pages/member-import/member-import.component").then((c) => c.MemberImportComponent),
    data: {
      breadcrumb: "Leden importeren",
      title: "Leden importeren",
      subscriptionTypes: [1],
      federations: [Federations.Vlamo],
    },
  },
  {
    path: MembersPaths.Update(":id", ":newId"),
    loadComponent: () =>
      import("./pages/member-update/member-update.component").then((c) => c.MemberUpdateComponent),
    data: {
      breadcrumb: "Persoonsgegevens nakijken",
      title: "Persoonsgegevens nakijken",
      subscriptionTypes: [1],
    },
  },
  {
    path: MembersPaths.Transfer,
    loadComponent: () =>
      import("./pages/member-transfer-start/member-transfer-start.component").then(
        (c) => c.MemberTransferStartComponent
      ),
    data: {
      breadcrumb: "Leden overzetten",
      title: "Leden overzetten",
      subscriptionTypes: [1],
      federations: [Federations.Vlamo],
    },
  },
  {
    path: MembersPaths.TransferTable(":draftId"),
    loadComponent: () =>
      import("./pages/member-transfer/member-transfer.component").then(
        (c) => c.MemberTransferComponent
      ),
    data: {
      breadcrumb: "Leden overzetten",
      title: "Leden overzetten",
      subscriptionTypes: [1],
      federations: [Federations.Vlamo],
    },
  },
] satisfies Route[];
